export const mapKeys = (obj, func) => Object.keys(obj).map(key => ({
  oldKey: key,
  newKey: func(key)
})).reduce((map, { oldKey, newKey }) => {
  map[newKey] = obj[oldKey]
  return map
}, {})

export default mapKeys
